import { useState } from 'react'
import AppModal from '../appModal/AppModal'
import ViewDataModal from './components/ViewDataModal'
import FirstModalMessage from './components/FirstModalMessage'
import SecondModalMessage from './components/SecondModalMessage'
import { pageVars } from '../../../../pages/const/pageVars'

const { ENTITIES, ACCOUNTS, LOCATIONS } = pageVars

const viewDataPages = [
  ENTITIES.codeText,
  ACCOUNTS.codeText,
  LOCATIONS.codeText
]

const ThreeStageModal = ({
  type,
  pageCodeText,
  open,
  setOpen,
  confirmFunction,
  viewDataItems
}) => {
  const [viewDataModalOpen, setViewDataModalOpen] = useState(false)
  const [secondModalOpen, setSecondModalOpen] = useState(false)

  const handleClose = () => setOpen(false)

  const openSecondModal = () => {
    setSecondModalOpen(true)
    setViewDataModalOpen(false)
  }

  const openViewDataModal = () => {
    setSecondModalOpen(false)
    setViewDataModalOpen(true)
  }

  const closeViewDataModal = () => {
    setSecondModalOpen(false)
    setViewDataModalOpen(false)
  }

  return (
    <>
      {/* First Modal */}
      {!secondModalOpen && !viewDataModalOpen && (
        <AppModal
          config={{
            type: type,
            open,
            handleClose,
            buttons: {
              actionButton: {
                text: 'Confirm',
                actionFunction: openSecondModal || handleClose,
                secondaryButton: false
              },
              // NOTE:
              // The data that will be dispalyed on the "VIEW DATA" page is not available from the backend
              // When available from the backend:
              // 1. remove false
              // 2. update the 'ViewDataModal' to display the data being passed to it
              // 3. depending on the incomming data format double check the "First Message" component to make sure it displays the right message
              ...(false && viewDataPages.includes(pageCodeText) &&
                viewDataItems && {
                  viewData: {
                    text: 'View Data',
                    actionFunction: openViewDataModal || handleClose,
                    secondaryButton: false
                  }
                }),
              cancel: {
                text: 'Cancel',
                actionFunction: handleClose,
                secondaryButton: true
              }
            }
          }}
        >
          {/* NOTE:
                The data that will be dispalyed on the "VIEW DATA" page is not available from the backend
                When available from the backend:
                    => depending on the incomming data format double check the "First Message" component to make sure it displays the right message
            */}
          <FirstModalMessage type={type} pageCodeText={pageCodeText} viewDataItems={viewDataItems} />
        </AppModal>
      )}
      {/* View Data Modal */}
      {/* NOTE:
                The data that will be dispalyed on the "VIEW DATA" page is not available from the backend
                When available from the backend:
                    => update the 'ViewDataModal' to display the data being passed to it
            */}
      {!secondModalOpen && viewDataModalOpen && (
        <ViewDataModal
          open={viewDataModalOpen}
          handleClose={closeViewDataModal}
          viewDataItems={viewDataItems}
        />
      )}
      {/* Second Modal */}
      {secondModalOpen && !viewDataModalOpen && (
        <AppModal
          config={{
            type: type,
            open,
            handleClose,
            buttons: {
              actionButton: {
                text:
                  (type === 'suspension' && 'Suspend') ||
                  (type === 'activation' && 'Activate') ||
                  (type === 'deletion' && 'Delete'),
                actionFunction: confirmFunction || handleClose,
                secondaryButton: false
              },
              cancel: {
                text: 'Cancel',
                actionFunction: handleClose,
                secondaryButton: true
              }
            }
          }}
        >
          <SecondModalMessage type={type} pageCodeText={pageCodeText}/>
        </AppModal>
      )}
    </>
  )
}

export default ThreeStageModal
